import $api from "@/frontend/shared/api/axios";

export async function patchPortfolioBulkAssignTags(ids: number[], tags: string[]) {
  const response = await $api.patch(`/tags/assign/portfolio-companies/bulk`, {
    portfolioCompanyIds: ids,
    tags
  });
  return response;
}
